import { mediaName } from '../model/media'

/** A local blob URL makes `download` work for media hosted on another origin, without opening a tab. */
export async function downloadMedia(url: string, signal: AbortSignal) {
  const response = await fetch(url, { signal, credentials: 'omit', cache: 'no-store' })
  if (!response.ok) throw new Error(`Download failed: ${response.status}`)
  const blob = await response.blob()
  if (signal.aborted) throw new DOMException('Download cancelled', 'AbortError')
  const objectUrl = URL.createObjectURL(blob)
  const link = document.createElement('a')
  link.href = objectUrl
  link.download = mediaName(url) || 'download'
  document.body.appendChild(link)
  try {
    link.click()
  } finally {
    link.remove()
    // Keep the blob alive long enough for the browser's download manager to acquire it.
    window.setTimeout(() => URL.revokeObjectURL(objectUrl), 60000)
  }
}
